import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/feedback.css';
import circle from '../assets/check_circle.png';

const FeedbackForm = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [explanation, setExplanation] = useState('');
  const [explanation2, setExplanation2] = useState('');
  const [explanation3, setFeedback] = useState(''); 
  const [showLoginDialog, setShowLoginDialog] = useState(false);


  const [feedbackresponse, setResponse] = useState({
    response1: '',
    explanation1: '',
    response2: '',
    explanation2: '',
  });

  // Each question gets its own selection (one per row)
  const [ratings, setRatings] = useState({
    uiInterview: '',
    support: '',
    speed: '',
    recommend: '',
  });
 //console.log("Ratings", ratings.uiInterview);
  const handleRatingChange = (questionKey, value) => {
    setRatings((prev) => ({
      ...prev,
      [questionKey]: value,
    }));
  };

    const handleResponseChange = (questionKey, value) => {
      setResponse(prev => ({
        ...prev,
        [questionKey]: value
      }));
    };

    console.log("Sending data:", {
      uiInterview: ratings.uiInterview,
      support: ratings.support,
      speed: ratings.speed,
      recommend: ratings.recommend,
      response1: feedbackresponse.response1,
      response2: feedbackresponse.response2,
    });
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log("Before handlesubmit")
    const formData = new URLSearchParams();
    formData.append('uiInterview', ratings.uiInterview);
    formData.append('support', ratings.support);
    formData.append('speed', ratings.speed);
    formData.append('recommend', ratings.recommend);
    formData.append('response1', feedbackresponse.response1);
    formData.append('answer', explanation); 
    formData.append('response2', feedbackresponse.response2);
    formData.append('answer2', explanation2); 
    formData.append('additionalfeedback', explanation3); 

    console.log("Sent data:", {
      uiInterview: ratings.uiInterview,
      support: ratings.support,
      speed: ratings.speed,
      recommend: ratings.recommend,
      response1: feedbackresponse.response1,
      response2: feedbackresponse.response2,
    });
    

    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbxvVsuSiThRewE0GyhpaXiouIEGkJjnect8sl6j-XEkwO0PiQKuKmjL99tDzrl2j-1zcQ/exec', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formData.toString()
      });
      console.log("going here");
      const text = await response.text();
      const result = JSON.parse(text);

      setRatings({
        uiInterview: '',
        support: '',
        speed: '',
        recommend: '',
      })
      setResponse({
        response1: '',
        response2:'',
      });

      setShowLoginDialog(true); 

    } catch (error) {
      setMessage('Something went wrong!');
      console.error('Fetch error:', error);
    }
    
  };

  const options = [
    'Very Unsatisfied',
    'Unsatisfied',
    'Neutral',
    'Satisfied',
    'Very Satisfied'
  ];

  return (
    <div className="Heading-container">
      <h2 className="heading">Feedback Form</h2>
      <div className='Question-container'>

      <form onSubmit={handleSubmit}>
        <table className="feedback-table">
          <thead>
            <tr>
              <th></th>
              {options.map((option) => (
                <th key={option}>{option}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>How satisfied are you with the overall product?</td>
              {options.map((option) => (
                <td key={option}>
                  <input
                    type="radio"
                    name="uiInterview"
                    value={option}
                    checked={ratings.uiInterview === option}
                    onChange={() => handleRatingChange('uiInterview', option)}
                    required
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td>How satisfied are you with the interview feedback??</td>
              {options.map((option) => (
                <td key={option}>
                  <input
                    type="radio"
                    name="support"
                    value={option}
                    checked={ratings.support === option}
                    onChange={() => handleRatingChange('support', option)}
                    required
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td>How satisfied were you with the ease of use of the product??</td>
              {options.map((option) => (
                <td key={option}>
                  <input
                    type="radio"
                    name="speed"
                    value={option}
                    checked={ratings.speed === option}
                    onChange={() => handleRatingChange('speed', option)}
                    required
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td> How likely are you to recommend this to your family or friend?</td>
              {options.map((option) => (
                <td key ={option}>
                  <input
                    type ="radio"
                    name="recommend"
                    checked={ratings.recommend === option}
                    onChange={() => handleRatingChange('recommend', option)}
                    required
                  />
                </td>
              ))}
            </tr>
          </tbody>
        </table>
        <div className='form-question-container'>
            <label className='form-question'>Were there any features missing that you expected? </label>
            <div className="response-feature">
            <label>
              <input
                type="radio"
                name="featureResponse"
                value="Yes"
                checked={feedbackresponse.response1 === 'Yes'}
                onChange= { () =>  {handleResponseChange('response1', 'Yes')}}
              />
              Yes
            </label>

            <label>
              <input
                type="radio"
                name="featureResponse"
                value="No"
                checked={feedbackresponse.response1 === 'No'}
                onChange= {() => {handleResponseChange('response1', 'No')}}
              />
              No
            </label>

          {/* ✅ Conditional Text Field */}
          {feedbackresponse.response1 === 'Yes' && (
            <div className="explanation-field">
              <label>Please explain what was missing:</label>
              <input
                type="text"
                value={explanation}
                onChange={(e) => setExplanation( e.target.value)}
                placeholder="Type your response"
                required
              />
            </div>
            )}  
            </div>


            <label className='form-question'>Did you encounter any usability issue? </label>
            <div className="response-feature">
            <label>
              <input
                type="radio"
                name="featureResponse2"
                value="Yes"
                checked={feedbackresponse.response2 === 'Yes'}
                onChange={() => {handleResponseChange('response2', 'Yes')}}
              />
              Yes
            </label>

            <label>
              <input
                type="radio"
                name="featureResponse2"
                value="No"
                checked={feedbackresponse.response2 === 'No'}
                onChange={() => {handleResponseChange('response2', 'No')}}
              />
              No
            </label>

          {/* ✅ Conditional Text Field */}
          {feedbackresponse.response2 === 'Yes' && (
            <div className="explanation-field">
              <label>Please tell us what was the issue:</label>
              <input
                type="text"
                value={explanation2}
                onChange={(e) => setExplanation2(e.target.value)}
                placeholder="Type your response"
                required
              />
            </div>
      )}  
            </div>
            
            <label className='form-question'>Any Additional Feedback</label>
            <div className="response-feature">
            <input
            type="text"
            className="feature"
            value={explanation3}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Type your response"
            />
            </div>          
            </div>
            <div className='button-container'>
        <button type="submit" className='submit'>Submit</button>
        </div>
            </form>
        </div>

        {showLoginDialog && (
        <div className="feedback-dialog-overlay">
          <div className="feedback-dialog">
            <img src={circle} className='image'></img>
            <h3>Feedback Received</h3>
            <p>Thank you for submitting the feedback.</p>
            <p>Do you want to continue?</p> 
            <button onClick={() => navigate('/')}
              className= "relogin"
               >Homepage</button>
            <button className="relogin" onClick={() => navigate('/interview-config')}>Interview</button>
            
          </div>
        </div>
      )}
       
        </div>

        
  );
};
export default FeedbackForm;
